import { render, staticRenderFns } from "./XInputTranslationUploadBatch.vue?vue&type=template&id=4a820dfe"
import script from "./XInputTranslationUploadBatch.vue?vue&type=script&lang=js"
export * from "./XInputTranslationUploadBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports